/**
 * A QR code as inline SVG (the `qrcode` library, loaded on demand). Low density: medium error
 * correction and a quiet zone; the caller adds the full-brightness white frame.
 */
import { useEffect, useState } from "react";

export function QrCode({ text, label }: { text: string; label: string }) {
  const [svg, setSvg] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    void import("qrcode").then((QR) =>
      QR.toString(text, { type: "svg", errorCorrectionLevel: "M", margin: 1 }).then((s) => {
        if (!cancelled) setSvg(s);
      }),
    );
    return () => {
      cancelled = true;
    };
  }, [text]);
  return (
    <div className="qr-frame" role="img" aria-label={label} data-qr={text}>
      {svg ? (
        <div style={{ width: "100%", height: "100%" }} dangerouslySetInnerHTML={{ __html: svg }} />
      ) : null}
    </div>
  );
}
